import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-2 w-full relative border-primary-normal border rounded-lg bg-border" }
const _hoisted_2 = { class: "flex items-center gap-4" }
const _hoisted_3 = { class: "w-12 h-12 border-primary-normal" }
const _hoisted_4 = { class: "flex flex-1 flex-col" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "" }, "Eingehender Anruf", -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: ""
}
const _hoisted_8 = { class: "" }
const _hoisted_9 = {
  key: 0,
  class: "animate-ping absolute w-6 h-6 -top-2 -left-2 bg-error rounded-full"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconItem = _resolveComponent("IconItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_IconItem, {
          class: "w-full h-full",
          path: _ctx.mdiPhoneIncoming
        }, null, 8, ["path"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        (_ctx.customer)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.customer.firstName) + " " + _toDisplayString(_ctx.customer.lastName), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, "Rufnummer: " + _toDisplayString(_ctx.call.incommingNumber), 1)),
        _createElementVNode("div", _hoisted_8, [
          (_ctx.customer)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: "flex items-center my-1 text-sm hover:text-primary-normal cursor-pointer",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.gotoCustomer && _ctx.gotoCustomer(...args)))
              }, " Kundenkartei öffnen "))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (_ctx.call.state == 'RINGING')
      ? (_openBlock(), _createElementBlock("div", _hoisted_9))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "absolute flex justify-center items-center w-6 h-6 top-0 right-0 cursor-pointer",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.setCallDone && _ctx.setCallDone(...args)))
    }, [
      _createVNode(_component_IconItem, { path: _ctx.mdiClose }, null, 8, ["path"])
    ])
  ]))
}